import { AdminMultimediaCollectionItem } from './admin-multimedia-collection-item';

export class AdminMultimediaChunk {
  public constructor(
    public readonly multimedia: AdminMultimediaCollectionItem[],
    public readonly total: number,
  ) {}
}
